var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "interests margin-t-2" }, [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c(
        "div",
        { ref: "width", staticClass: "container-fluid" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn btn-info",
              attrs: {
                to: {
                  name: "talent.profile.show",
                  params: { id: this.userId },
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-chevron-left" }),
              _vm._v(" Back\n      "),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c(
        "div",
        { staticClass: "dashboard-block" },
        [
          _c(
            "ul",
            { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
            [
              _c(
                "li",
                { class: { active: _vm.page === "interests" } },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          params: { page: "interests" },
                          query: _vm.$route.query,
                        },
                      },
                    },
                    [_vm._v("Interests")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: { active: _vm.page === "specialist" } },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          params: { page: "specialist" },
                          query: _vm.$route.query,
                        },
                      },
                    },
                    [_vm._v("Specialist Topics")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: { active: _vm.page === "personal" } },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          params: { page: "personal" },
                          query: _vm.$route.query,
                        },
                      },
                    },
                    [_vm._v("Hobbies")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("profile-interest-categories", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.page === "interests",
                expression: "page === 'interests'",
              },
            ],
            attrs: {
              "interest-categories": _vm.interestCategories,
              "custom-categories": _vm.customCategories,
              "selected-categories": _vm.selectedCategories,
            },
            on: {
              toggled: _vm.toggleInterestCategory,
              selected: (option) => {
                _vm.selectInterestCategory(option, "interest")
              },
              deleted: _vm.deleteInterestCategory,
            },
          }),
          _vm._v(" "),
          _c("profile-specialist-categories", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.page === "specialist",
                expression: "page === 'specialist'",
              },
            ],
            attrs: {
              "interest-categories": _vm.interestCategories,
              "custom-categories": _vm.customCategories,
              "selected-categories": _vm.selectedCategories,
            },
            on: {
              toggled: _vm.toggleSpecialistCategory,
              selected: (option) => {
                _vm.selectInterestCategory(option, "specialist")
              },
            },
          }),
          _vm._v(" "),
          _c("profile-personal-interests", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.page === "personal",
                expression: "page === 'personal'",
              },
            ],
            attrs: {
              "personal-interests": _vm.personalInterests,
              "suggested-personal-interests": _vm.suggestedPersonalInterests,
            },
            on: {
              unselect: _vm.unselectPersonalInterest,
              selected: _vm.selectPersonalInterest,
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid",
        class: _vm.fixed ? "fixed" : "relative",
        staticStyle: { width: "100%" },
        style:
          "max-width: " + _vm.width + "px;" + "min-width: " + _vm.width + "px",
      },
      [
        _c("div", { staticClass: "flex footer" }, [
          _c("div", { staticClass: "hidden-xs" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.footerContent.content) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row align-center" },
            [
              _c("div", { staticClass: "spacer-r-1 hidden-xs" }, [
                _vm._v(_vm._s(_vm.footerContent.count) + " Selected"),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "btn btn-primary",
                  attrs: { to: _vm.footerContent.link },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.footerContent.button) +
                      "\n          "
                  ),
                  _vm.footerContent.icon
                    ? _c("i", {
                        staticClass: "spacer-l-1 fa",
                        class: _vm.footerContent.icon,
                      })
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }